import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class Station extends Model<Schemas['stations'], Models> {}
